import $ from 'jquery';
import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import { Document } from '@mabinso-registry/module-commons';
import ReportSavedModel from '../../components/report/models/ReportSavedModel';
import Globals from '../../utils/Globals';
import ReportListView from './views/ReportListView';
import Detail from './components/detail/Detail';
// import DocumentComponent from '../document/Document';
import NewReport from './components/newReport/NewReport';
import ReportCategoryView from './views/ReportCategoryView';

type LState = {
    modelValues: Object;
    reportId: string | number;
};

type ReportProps = {
    spinner: any;
    enableHelp: any;
};

const Report = (props: ReportProps) => {
    let actview: any;
    const location = useLocation();
    const navigate = useNavigate();

    const history = {
        push: (path, state) => {
        navigate(path, { state });
        },
    };


    useEffect(() => {
        actview = new ReportListView({ navigate, enableHelp: props.enableHelp });
        $('#report_component').html(actview.el);
        actview.render();
        props.spinner(false);
    }, []);

    const addNewReportSaved = (reportId: string | number, reportSavedValues: Object) => {
        actview.reportCategoryViews.forEach((reportCategoryView: ReportCategoryView) => {
            reportCategoryView.reportViews.forEach((reportView: any) => {
                const reportModel = reportView.model;
                if (reportModel.id === reportId) {
                    const reportSavedModel = new ReportSavedModel(reportSavedValues);
                    const reportSavedView = reportView.addReportSavedView(new ReportSavedModel(reportSavedValues), 'after');
                    reportCategoryView.triggerReports(true);
                    reportView.triggerReportsSaved(true);
                    if (reportSavedModel.get('finished') != null && reportSavedModel.get('fail') === false && reportSavedModel.get('pages') > 0) {
                        reportSavedView.triggerReport(reportSavedModel.get('showDefault'));
                    } else if (reportSavedModel.get('finished') == null) {
                        console.log('Finished');
                    }
                }
            });
        });
    };

    useEffect(() => {
        const { state } = location;
        console.log(props, actview.reportCategoryViews);
        if (state && state.modelValues && state.reportId) {
            addNewReportSaved(state.reportId, state.modelValues);
        }
        Globals.nextPath = location as any;
    }, [location.state]);

    return (
        <div id="report_component_wrapper">
            <div id="report_component" />
            <Routes>
                <Route path="newReport/:reportId" element={<NewReport {...props} />} />
                <Route
                    path=":reportSavedId"
                    element={
                        <div id="report_detail">
                            <Document history={history} closeLink="/index.reports" enableHelp={props.enableHelp} {...props}>
                                <Detail {...props} />
                            </Document>
                            <div id="Report-Detail-Spinner">hello</div>
                        </div>
                    }
                />
            </Routes>
        </div>
    );
};

export default Report;
